export const bulletinInitialState = {
  bulletins: {
    data: [],
    loading: false,
    error: null,
    total: 0,
  },
  selectedBulletinIds: [],
  removeBulletins: {
    loading: false,
    error: null,
  },
};
